<div class="encabezado">
  <div class="col-4 getBack">
    <a routerLink="/settings" class="getBack">
      <span
        ><i class="icon-chevron-left"></i>{{ "forms.buttons.back" | translate }}
      </span></a
    >
  </div>
  <div class="">
    <div class="">
      <div>
        <h5 class="titulo1">
          {{ "titles-menu-pages.tags" | translate }}
        </h5>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="btn-izq">
        <button class="btn btn-hover" type="button" (click)="toggleForm()">
          {{ "buttons.add+" | translate }} <i class="icon-plus"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="tabla">
    <div class="table-responsive-wrapper">
    <div class="table-scroll-inner">
    <table
      mat-table
      class="full-width-table"
      matSort
      aria-label="Brands"
      [dataSource]="dataSource"
    >
      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.rule_name" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>
      <!-- description Column -->
      <ng-container matColumnDef="entity">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.rule_entity" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.entity }}</td>
      </ng-container>
      <!-- hex Column -->
      <ng-container matColumnDef="hex">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.hex" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="color-box" [style.background-color]="row.hex"></div>
        </td>
      </ng-container>
      <!-- rowActions Column -->
      <ng-container matColumnDef="rowActions">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="cabecera-tabla"
        >
          {{ "inputs.actions" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <i
            class="icon-pencil text-success icon-actions"
            (click)="getTags(row.reference)"
          ></i>
          <i
            class="icon-trash2 text-danger icon-actions"
            (click)="deleteTags(row.reference)"
          ></i>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    </div>
    </div>
    <!-- Card layout mobile -->
    <div class="cards-mobile-wrapper">
      <div *ngFor="let row of dataSource.data" class="settings-card" (click)="getTags($any(row).reference)">
        <div class="card-header-row">
          <span class="card-name">{{ $any(row).name }}</span>
          <div class="color-box" [style.background-color]="$any(row).hex"></div>
        </div>
        <div class="card-body-content">
          <span class="card-detail">{{ $any(row).entity }}</span>
        </div>
        <div class="card-footer-row">
          <div class="card-actions">
            <i class="icon-pencil text-success icon-actions" (click)="getTags($any(row).reference); $event.stopPropagation()"></i>
            <i class="icon-trash2 text-danger icon-actions" (click)="deleteTags($any(row).reference); $event.stopPropagation()"></i>
          </div>
        </div>
      </div>
    </div>
    <mat-paginator
      #paginator
      [pageSizeOptions]="[5, 10, 25]"
      (page)="onPageChange($event)"
      aria-label="Select page"
    >
    </mat-paginator>
  </div>
</div>
<div
  class="formulario-derecha-container"
  [ngClass]="{ 'mostrar-formulario': showForm }"
>
  <app-form-add-tags
    [tagsData]="tagsData"
    (backButtonClick)="cerrarFormulario()"
    (addTags)="refrescar()"
  ></app-form-add-tags>
</div>
<div class="overlay" *ngIf="showForm"></div>
